import { findDeepGetActivityOfTask } from '../../../../views/lookahead/planification/index.helper';
import { collapseExpandActivity } from '../../GanttVisualization.helper';

function action(cell, e, showDrawer) {
  const taskId = cell.getAttribute('data-task-id');
  const openCardBtn = e.target.closest('.open-card-button-new');
  const collapseBtn = e.target.closest('.collapse-expand-gantt');

  if (openCardBtn) {
    openDrawer(taskId, showDrawer);
  }

  if (collapseBtn) {
    collapseExpand(taskId);
  }
}

function openDrawer(taskId, showDrawer = () => {}) {
  const thisTask = window.ganttVisualization.getTask(taskId);
  const findAct = findDeepGetActivityOfTask(window.activities, 'id', taskId);
  showDrawer(thisTask, findAct);
}

function collapseExpand(taskId) {
  const thisTask = window.ganttVisualization.getTask(taskId);
  collapseExpandActivity(thisTask, window.ganttVisualization);
}

export default action;
